module.exports = __webpack_public_path__ + "static/media/icn_selection_on.fc3c2e65.svg";